import { render, staticRenderFns } from "./SaleAdmin.vue?vue&type=template&id=4d18659c"
import script from "./SaleAdmin.vue?vue&type=script&lang=js"
export * from "./SaleAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports